import withData from '../../../elements/Select/withData'
import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import React, { Component } from 'react'
import { Col, DatePicker, Form, Input, Row, Select } from 'antd'
import { compose } from 'recompose'
import { get, isEmpty } from 'lodash'
import withLoadingSection from '../../../elements/HOC/withLoadingSection'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withSpinning from '../../../elements/HOC/withSpinning'
import { arrVal, normalizeNull, sessionItemByKeys, strVal } from '../../../modules/Utils'

const { RangePicker } = DatePicker
const { TextArea } = Input
const { Option } = Select

class StatementForm extends Component {
  state = {
    type: '',
    company: '',
    url: '',
    multiCurrency: [],
    BankSelectCmp: Select,
  }

  async componentDidMount() {
    const company = get(this.props.statement, 'company._id')
    if (company) {
      await this.onChangeCompany(company)
      await this.onChangeBank(get(this.props, 'statement.bank._id'))
    }
  }

  onChangeCompany = (company) => {
    this.props.form.resetFields(['bank._id', 'currency'])
    if (!isEmpty(company)) {
      const url = `corporates/banks/?status=Active` + (isEmpty(company) ? '' : `&owner=${company}`)
      const BankSelectCmp = compose(
        withUrlFetch({
          name: 'banks',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
      this.props.form.resetFields(['bank._id', 'currency'])
      this.setState({ company, BankSelectCmp, url })
    } else {
      this.setState({ company: undefined, BankSelectCmp: Select })
    }
  }
  onChangeBank = (bank) => {
    let sessionID = `banks_${this.state.url}_dropdown`
    const currency = strVal(sessionItemByKeys(sessionID, bank, '_id', 'bank'), 'currency')
    const multiCurrency = arrVal(sessionItemByKeys(sessionID, bank, '_id', 'bank'), 'multiCurrency')
    this.props.form.setFieldsValue({
      currency,
    })
    this.setState({
      currency,
      multiCurrency,
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { statement } = this.props
    const { BankSelectCmp, multiCurrency, currency } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16, offset: 1 },
      },
    }
    return (
      <Form layout={'horizontal'}>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label="Type">
              {getFieldDecorator('type', {
                initialValue: get(statement, 'type'),
                rules: rules.select,
              })(<Type />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Company'}>
              {getFieldDecorator('company._id', {
                initialValue: get(statement, 'company._id'),
                rules: [{ required: true, message: 'Please Select a Company!' }],
              })(<OrganisationsSelect onChange={this.onChangeCompany} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Bank Account'}>
              {getFieldDecorator('bank._id', {
                initialValue: get(statement, 'bank._id'),
                rules: [{ required: true, message: "Bank Account Can't be empty!" }],
              })(
                <BankSelectCmp
                  onChange={this.onChangeBank}
                  style={{ width: '100%' }}
                  keyAtr={'_id'}
                  valueAtr={'title'}
                  placeholder={'Bank Account'}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Statement Number'}>
              {getFieldDecorator('no', {
                initialValue: get(statement, 'no'),
                rules: [
                  {
                    required: true,
                    message: "Statement Number Can't be empty !",
                  },
                ],
              })(<Input placeholder={'Statement Number'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Statement Date'}>
              {getFieldDecorator('date', {
                initialValue: get(statement, 'date'),
                rules: [{ required: true, message: "Statement Date Can't be empty!" }],
              })(<DatePicker />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Statement Period'}>
              {getFieldDecorator('period', {
                initialValue: get(statement, 'period'),
                rules: [{ required: true, message: "Statement Period Can't be empty!" }],
              })(<RangePicker style={{ width: '100%' }} format="ddd YYYY-MM-DD" />)}
            </Form.Item>
          </Col>
        </Row>
        {multiCurrency.length > 0 && <h3>Main Account Currency</h3>}
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Opening Balance'}>
              {getFieldDecorator('balance.opening', {
                initialValue: get(statement, 'balance.opening'),
                rules: [{ required: true, message: "Opening Balance Can't be empty!" }],
              })(
                <Input type="number" addonBefore={currency} style={{ width: '100%' }} placeholder={'Opening Balance'} />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Closing Balance'}>
              {getFieldDecorator('balance.closing', {
                initialValue: get(statement, 'balance.closing'),
                rules: [{ required: true, message: "Closing Balance Can't be empty!" }],
              })(
                <Input
                  type={'number'}
                  addonBefore={currency}
                  placeholder={'Closing Balance'}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Total Credit Amount'}>
              {getFieldDecorator('amount.credit', {
                normalize: normalizeNull,
                initialValue: get(statement, 'amount.credit'),
              })(
                <Input
                  type={'number'}
                  addonBefore={currency}
                  placeholder={'Total Credit Amount'}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Total Debit Amount'}>
              {getFieldDecorator('amount.debit', {
                normalize: normalizeNull,
                initialValue: get(statement, 'amount.debit'),
              })(
                <Input
                  type={'number'}
                  addonBefore={currency}
                  placeholder={'Total Debit Amount'}
                  style={{ width: '100%' }}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        {multiCurrency.length > 0 && <h3>Virtual Account Currencies</h3>}
        {multiCurrency.map((c, i) => (
          <Row>
            <h4 style={{ color: '#479365', fontWeight: 'bold', paddingLeft: 20 }}>{c}</h4>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Opening Balance'}>
                {getFieldDecorator(`multiCurrency.${i}.${c}.balance.opening`, {
                  initialValue: get(statement, `multiCurrency.${i}.${c}.balance.opening`),
                  normalize: normalizeNull,
                })(<Input type="number" addonBefore={c} style={{ width: '100%' }} placeholder={'Opening Balance'} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Closing Balance'}>
                {getFieldDecorator(`multiCurrency.${i}.${c}.balance.closing`, {
                  initialValue: get(statement, `multiCurrency.${i}.${c}.balance.closing`),
                  normalize: normalizeNull,
                })(<Input type={'number'} addonBefore={c} placeholder={'Closing Balance'} style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Total Credit Amount'}>
                {getFieldDecorator(`multiCurrency.${i}.${c}.amount.credit`, {
                  normalize: normalizeNull,
                  initialValue: get(statement, `multiCurrency.${i}.${c}.amount.credit`),
                })(
                  <Input
                    type={'number'}
                    addonBefore={c}
                    placeholder={'Total Credit Amount'}
                    style={{ width: '100%' }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Total Debit Amount'}>
                {getFieldDecorator(`multiCurrency.${i}.${c}.amount.debit`, {
                  normalize: normalizeNull,
                  initialValue: get(statement, `multiCurrency.${i}.${c}.amount.debit`),
                })(
                  <Input type={'number'} addonBefore={c} placeholder={'Total Debit Amount'} style={{ width: '100%' }} />
                )}
              </Form.Item>
            </Col>
          </Row>
        ))}
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Notes'}>
              {getFieldDecorator('notes', {
                normalize: normalizeNull,
                initialValue: get(statement, 'notes'),
              })(<TextArea placeholder={'Notes'} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

const Type = compose(
  withData({
    data: [
      {
        key: 'bank',
        value: 'Account',
      },
      {
        key: 'lender',
        value: 'Loan',
      },
      {
        key: 'card',
        value: 'Credit Card',
      },
    ],
  }),
  withSort
)(CustomSelect)

StatementForm.propTypes = {}
StatementForm.defaultProps = { statement: {}, type: 'new' }

export default compose(Form.create(), withLoadingSection)(StatementForm)
